import io from "socket.io-client";
import localUtils from "@common/helpers/localStorage.utils";

let socket;

export function* connectionSocket() {
    if (window.api_routes.socket_Domain.indexOf("/websocket") > -1) {
      var connectUrl = window.api_routes.socket_Domain.replace("/websocket", "");
      socket = io.connect(connectUrl, { path: "/websocket/socket.io/" });
    } else socket = io.connect(window.api_routes.socket_Domain);

    socket.on("connect", function() {
      socket.emit("join-room", [localUtils.getUser()]);
    });
}
 export function socketIO(){
     return socket;
 }